import { useContext } from 'react';
import { SiteChromeStaticContext } from "./SiteChromeStaticContext";
export var useSiteChromeStaticContext = function useSiteChromeStaticContext() {
  var context = useContext(SiteChromeStaticContext);
  if (context === undefined) {
    throw new Error('useSiteChromeStaticContext must be used within a SiteChromeStaticContextProvider');
  }
  return context;
};